var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn font-weight-light mx-1",attrs:{"color":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default",[_c('span',{staticClass:"default"},[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }